// Login pages: the CoachHub login (/login), an institute's own login page (/login/<slug>),
// register and password reset. They follow the user's light/dark choice (they have a theme switch).
const AUTH_PATHS = ['/login', '/register', '/reset-password'];
const INSTITUTE_LOGIN = /^\/login\/[^/]+\/?$/;
const STORAGE_KEY = 'coachhub_login_page';

export function isInstituteLoginRoute(path) {
  return INSTITUTE_LOGIN.test(path || '');
}

export function isAuthRoute(path) {
  return AUTH_PATHS.includes(path || '') || isInstituteLoginRoute(path);
}

// An institute's login page opened on this device is where a signed-out person goes back to
// (session expired, the installed app opened signed out): like a real app of that institute.
export function rememberLoginPage(slug) {
  try {
    if (slug) localStorage.setItem(STORAGE_KEY, slug);
  } catch { /* storage blocked: the CoachHub login is used */ }
}

export function forgetLoginPage() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* nothing saved */ }
}

export function loginPath() {
  try {
    const slug = localStorage.getItem(STORAGE_KEY);
    return slug ? `/login/${encodeURIComponent(slug)}` : '/login';
  } catch {
    return '/login';
  }
}
